import actions from "./action_types";
import axios from "axios";
import mutations from "./mutation_types";
import action_types from "../action_types";

export default {
    [actions.FETCH_CONTRACTOR_HISTORY]: function(store, options) {
        const params = store.getters.getContractorHistoryGetParams(options.index);
        return axios.get('/summaries/contractor-history/contractor-history/' + options.contractor_id, { params })
            .then(response => {
                let contractorData = {
                    index: options.index,
                    data: response.data
                };
                store.commit(mutations.SET_CONTRACTOR_DATA, contractorData);
            })
            .catch(error => {
                console.log(error.message);
            });
    },
    [actions.RESET_CONTRACTOR_HISTORY]: function (store, options) {

        let contractorData = {
            index: options.index,
            data: {
                contractor: {
                    id: 0,
                },
                unallocated_documents: [],
                unallocated_payments: [],
                documents: [],
                payment_corrections: [],
            }
        };
        store.commit(mutations.SET_CONTRACTOR_DATA, contractorData);

    },
    [actions.REFRESH_CONTRACTOR_HISTORY]: function(store) {
        store.state.contractorsData.forEach((data, index) => {
            store.dispatch(action_types.FETCH_CONTRACTOR_HISTORY, {
                contractor_id: data.contractor.id,
                index: index
            })
        })
    },
    [action_types.CHECK_IF_CONNECTED]: function(store, input_data) {
        return axios.post('/summaries/contractor-history/check-connected', input_data)
            .catch(error => console.log(error))
    },

    [action_types.CHECK_CAN_CONNECT]: function(store, input_data) {
        return axios.post('/summaries/contractor-history/check-can-connect', input_data)
            .catch(error => console.log(error))
    },
    [action_types.DELETE_LOCKS]: function(store, input_data) {
        return axios.post('/summaries/contractor-history/delete-locks', input_data)
            .catch(error => console.log(error))
    },
    [action_types.DELETE_CONNECTED]: function(store, input_data) {
        return axios.post('/summaries/contractor-history/delete-connected', input_data)
            .catch(error => console.log(error))
    },
}
